export const REGISTER_TEST_BY_NAME = 'REGISTER_TEST_BY_NAME';
